/** ================================
 * Action
 ================================ */
export const cutStencils = [
  "StraightCutStencil",
  "CurvedCutStencil",
  "AngledCutStencil",
  "AngleCurveCutStencil",
  "CurveAngleCutStencil",
  "DoubleCurvedCutStencil",
  "AngleDoubleCurveCutStencil",
] as const;
export type CutStencilName = (typeof cutStencils)[number];

export const screenStencils = [
  "StraightScreenStencil",
  "CurvedScreenStencil",
  "AngledScreenStencil",
  "AngleCurveScreenStencil",
  "CurveAngleScreenStencil",
  "DoubleCurvedScreenStencil",
  "AngleDoubleCurveScreenStencil",
] as const;
export type ScreenStencilName = (typeof screenStencils)[number];

export const passStencils = [
  "StraightPassStencil",
  "CurvedPassStencil",
  "AngledPassStencil",
  "AngleCurvePassStencil",
  "CurveAnglePassStencil",
  "DoubleCurvedPassStencil",
  "AngleDoubleCurvePassStencil",
] as const;
export type PassStencilName = (typeof passStencils)[number];

export const hashpassStencils = [
  "StraightHashpass",
  "HashPass1Stencil",
  "HashPass2Stencil",
  "HashPass3Stencil",
  "HashPass4Stencil",
  "HashPass5Stencil",
  "CurvedHashpass",
  "HashPass1CurveStencil",
  "HashPass2CurveStencil",
  "HashPass3CurveStencil",
  "HashPass4CurveStencil",
  "HashPass5CurveStencil",
] as const;
export type HashpassStencilName = (typeof hashpassStencils)[number];

export const handoffStencils = ["HandoffStencil"] as const;
export type HandoffStencilName = (typeof handoffStencils)[number];

export const dribbleStencils = [
  "StraightDribbleStencil",
  "CurvedDribbleStencil",
  "AngledDribbleStencil",
  "AngleCurveDribbleStencil",
  "CurveAngleDribbleStencil",
  "DoubleCurvedDribbleStencil",
  "AngleDoubleCurveDribbleStencil",
] as const;
export type DribbleStencilName = (typeof dribbleStencils)[number];

export const freeDrawStencils = ["MultiSegmentStencil"] as const;
export type FreeDrawStencilName = (typeof freeDrawStencils)[number];

export const actionStencilNames = [
  ...cutStencils,
  ...screenStencils,
  ...passStencils,
  ...hashpassStencils,
  ...handoffStencils,
  ...dribbleStencils,
  ...freeDrawStencils,
] as const;
export type ActionStencilName = (typeof actionStencilNames)[number];

/** ================================
 * Marker
 ================================ */
/** ======== Player ======== */
export const playerStencils = ["BasketballPlayerStencil"] as const;
export type PlayerStencilName = (typeof playerStencils)[number];

/** ======== Ball ======== */
export const ballStencils = ["PossessionStencil"] as const;
export type BallStencilName = (typeof ballStencils)[number];

/** ======== Text ======== */
export const textBoxStencils = ["FreeTextStencil"] as const;
export type TextBoxStencilName = (typeof textBoxStencils)[number];

/** ======== Misc ======== */
export const miscStencils = ["HoopStencil", "BallStencil", "FlagStencil", "ConeStencil"] as const;
export type MiscStencilName = (typeof miscStencils)[number];

/** ======== Shading ======== */
export const shadingStencils = ["RectangleShadingStencil", "OvalShadingStencil", "TrapezoidShadingStencil"] as const;
export type ShadingStencilName = (typeof shadingStencils)[number];

export const markerStencilNames = [
  ...playerStencils,
  ...ballStencils,
  ...textBoxStencils,
  ...miscStencils,
  ...shadingStencils,
] as const;
export type MarkerStencilName = (typeof markerStencilNames)[number];

export enum MotionType {
  NONE = "NONE",
  BALL = "BALL",
  PASS = "PASS",
  CUT = "CUT",
  SCREEN = "SCREEN",
  DRIBBLE = "DRIBBLE",
  HANDOFF = "HANDOFF",
  CUT_RECEIVING_HANDOFF = "CUT_RECEIVING_HANDOFF",
  SCREEN_RECEIVING_HANDOFF = "SCREEN_RECEIVING_HANDOFF",
}
